import {SUBMIT_SUPPORT_FORM, SUBMIT_SUPPORT_FORM_RESET} from "../actions/support";

const initialState = {
    submitSupportFormSuccess: null,
    submitSupportFormError: null,
};

export default function supportReducer(state = initialState, action) {
    switch (action.type) {
        case SUBMIT_SUPPORT_FORM:
            return {
                ...state,
                ...(action.payload.submitted && {submitSupportFormSuccess: true}),
                submitSupportFormError: action.error,
            };
        case SUBMIT_SUPPORT_FORM_RESET:
            return {
                ...state,
                submitSupportFormSuccess: initialState.submitSupportFormSuccess,
                submitSupportFormError: initialState.submitSupportFormError
            };
        default:
            return state;
    }
}